import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<>
			<div className=' bg-white'>
				<div className=' w-full border-[1px]  border-black border-opacity-30 ' />
				<footer className=' flex flex-row justify-center items-center md:py-4 py-2 md:text-sm text-xs  '>
					{/* <p>© 2024 . Made By ❤️ <Link to={"https://www.parthivisoftwares.com"} target='#'>Parthivi Software Solution</Link> </p> */}
					<p className=' text-center'>
						<span className=' font-semibold'>Order Management System</span> Develop and Maintain by{' '}
						<Link
							className=' text-red-500 hover:text-red-600 font-semibold'
							to={'https://www.parthivisoftwares.com'}
							target='#'>
							Parthivi Software Solution
						</Link>{' '}
						© Client name{' '}
					</p>
				</footer>
			</div>
		</>
	);
};

export default Footer;
